const prefix = '@@snackbar';

const OPEN_SNACKBAR = `${prefix}/OPEN_SNACKBAR`;
const CLOSE_SNACKBAR = `${prefix}/CLOSE_SNACKBAR`;

export {
    OPEN_SNACKBAR,
    CLOSE_SNACKBAR,
};
